{
	"slTp": {
		"title": "Stop Loss / Take Profit",
		"price": "Цена",
		"confirm": "Подтвердить",
		"stopLoss": "Stop Loss",
		"takeProfit": "Take Profit",
		"stopLossShort": "SL",
		"takeProfitShort": "TP",
		"positionsSuccessCreated": "Позиция успешно создана!",
		"cantCreatePosition": "Не удалось создать позицию.",
		"close": "Закрыть",
		"positionSize": "Объем позиции",
		"trailingStop": "Трейлинг-стоп"
	}
}
